<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name" style="color: #303133">本月维修总收入：</div>
                <div class="search-name" style="margin-left: 0px; font-weight: bold; font-size: medium; color: green">￥{{ summary }}</div>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">订单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="请输入订单号"></el-input>
                <div class="search-name">创建时间</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                <el-table-column show-overflow-tooltip width="190px" prop="OrderCode" label="订单号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="UName" label="车主"></el-table-column>
                <el-table-column show-overflow-tooltip prop="ProductAmount" label="订单总金额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="GoodsCount" label="商品数量"></el-table-column>
                <el-table-column show-overflow-tooltip prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="StateName" label="状态"></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.see" title="查看详情" size="mini" type="text" @click="gotoDetails(scope.$index, scope.row)">{{ permission.see }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.BeginDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        timePicker,
        breadcrumb,
        elTableColumn
    },
    name: '',
    data() {
        return {
            timeVisible: false,
            summary: '',
            dialogVisible: false,
            searchData: {
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                OrderCode: '',
                BeginDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {}
        };
    },
    mounted() {
        this.getSummary();
        this.getTableData();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('RepairOrder');
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.BeginDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        resetSearch() {
            this.searchData = {
                EntpId: this.searchData.EntpId,
                OrderCode: '',
                BeginDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/GetCurrentMonthRepairList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        getSummary() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/GetCurrentMonthRepairSummary',
                    data: {
                        entpId: this.searchData.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data.TotalIncomeAmount;
                    this.summary = data;
                })
                .catch(() => {});
        },
        gotoDetails(index, row) {
            this.$router.push(`/repairMamage/orderDetails?OrderId=${row.OrderId}`);
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
